export class OpenBasket {
    constructor(optionalOptions = {}) {
        this._buttons = document.querySelectorAll('.open-basket');

        if (!this._buttons) {
            this.destructor();
            return true;
        }

        this._buttons.forEach((button) => {
            button.addEventListener("click", (event) => {
                if (documentWrap.classList.contains('basket-show')) {
                    docBody.classList.remove('open-basket')
                    area.classList.remove('show')
                    documentWrap.classList.remove('basket-show')
                } else {
                    docBody.classList.add('open-basket')
                    documentWrap.classList.add('basket-show')
                    area.classList.add('show')
                }
            })
        })

        let docBody = document.querySelector('body');
        let documentWrap = document.getElementById('wrap-wrap');
        let area = document.getElementById('basket-area');

        if (area.querySelector('.basket-area--close')) {
            area.querySelector('.basket-area--close').addEventListener("click", (event) => {
                docBody.classList.remove('open-basket')
                area.classList.remove('show')
                documentWrap.classList.remove('basket-show')
            })
        }

        //if (documentWrap.classList.contains('basket-show')) {
        //    document.querySelector('.user-show-menu--overlay').addEventListener("click", (event) => {
        //        area.classList.remove('show')
        //        documentWrap.classList.remove('user-show-menu')
        //    });
        //}
    }

    destructor() {
        this._buttons = null;
    }
}

export default new OpenBasket();